import LocationSelect from '@/components/location-select/index.vue';
import { mapGetters } from 'vuex';
import RegExp from '@/utils/regExp.js';
import Bus from '../../bus.js';

export default {
  components: {
    LocationSelect
  },
  data() {
    return {
      areaCode: '',
      enterpriseNatureList: [], // 企业性质字典
      isShowProvince: false, // 是否显示省份
      form: {
        companyName: '',
        city: '',
        county: '',
        township: '',
        village: '',
        email: '',
        address: '',
        creditCode: '',
        enterpriseNature: ''
      },
      rules: {
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur'}
        ],
        creditCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur'}
        ],
        village: [
          { required: true, message: '请选择完整的企业地址', trigger: 'change'}
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur'}
        ],
        enterpriseNature: [
          { required: true, message: '请选择企业性质', trigger: 'change'}
        ],
        email: [
          { pattern: RegExp.email, message: '请输入正确的电子邮箱', trigger: 'blur'}
        ]

      }
    };
  },
  created() {
    // 企业展示省份
    if (this.userType === 2) {
      this.isShowProvince = true;
    }
    this.initRules();
    this.$store.dispatch('getSelectDictList', 'ENTERPRISE_NATURE').then(res => {
      if (res.code === '0') {
        this.enterpriseNatureList = res.data;
      }
    });
  },
  computed: {
    ...mapGetters([
      'userType'
    ])
  },
  watch: {
    'form.creditCode'(){
      Bus.$emit('msg', this.form.creditCode);
    }
  },
  methods: {
    initRules() {
      if (this.userType === 3) {
        this.rules = {
          companyName: [
            { required: true, message: '农村集体经济组织名称', trigger: 'change'}
          ],
          creditCode: [
            { required: true, message: '统一社会信用代码', trigger: 'blur'}
          ],
          village: [
            { required: true, message: '请选择完整的村地址', trigger: 'change'}
          ],
          address: [
            { required: true, message: '请输入详细地址', trigger: 'blur'}
          ],
          email: [
            { pattern: RegExp.email, message: '请输入正确的电子邮箱', trigger: 'blur'}
          ]
        };
      }
    },
    areaCodeChange(event) {
      this.areaCode = event.areaCode;
      const key = event && event.type;
      this.form[key] = event.areaCode;
    },
    validateForm() {
      let isValid = false;
      this.$refs['form'].validate(valid => {
        isValid = valid;
      });
      return isValid;
    },
    // 开户名称
    updateName() {
      this.$store.commit('UPDATE_ACC_NAME', this.form.companyName );
    }
  }

};
